import { NgModule } from '@angular/core';
import { FiAutomatedActionRecipientSelectComponent } from './automated-action-recipient-select.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SelectSearchModule } from '../fi-select-search/select-search.module';
import { FiUserContactChipGridInputModule } from '../fi-user-contact-chip-grid-input/fi-user-contact-chip-grid-input.module';
import { FiAutomatedActionRecipientHelperService } from './automated-action-recipient-select-helper.service';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatSelectModule,
        FiAppTextSharedModule,
        MatFormFieldModule,
        SelectSearchModule,
        FiUserContactChipGridInputModule,
    ],
    declarations: [FiAutomatedActionRecipientSelectComponent],
    exports: [FiAutomatedActionRecipientSelectComponent],
    providers: [FiAutomatedActionRecipientHelperService],
})
export class FiAutomatedActionRecipientSelectModule {}
